import React, { Component } from "react";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  injectStripe
} from "react-stripe-elements";
import "./checkoutPages.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import amex from '../../assets/images/cardicons/amex.png'
import discovercard from '../../assets/images/cardicons/discovercard.png'
import mastercard from '../../assets/images/cardicons/mastercard.png'
import visa from '../../assets/images/cardicons/visa.png'

const style = {
  base: {
    lineHeight: '20px',
    color: '#fff',
    fontFamily: 'Roboto Condensed',
    fontSize: '16px',
    fontWeight: 'normal',
    '::placeholder': {
      color: '#999',
      fontWeight: 'normal',
      fontSize: '16px'
    },
  },
};
class CheckoutForm extends Component<any> {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  public async submit(ev) {
    ev.preventDefault()
    if (this.props.formFilled()) {
      this.props.StartProcessing();
      console.log(ev);
      const {token} = await this.props.stripe.createToken({name: "Name"});
      console.log(token);
      this.props.onSuccess(token);
    }
    else {
      console.log('not all forms filled')
    }
 
  }

  public handleSuccess(res) {
    toast.success("Great! Now Login In to Performance Learning and Shine");
    this.props.togglePaymentState();
  }

  public handleFail(res) {
    // get error details
    toast.error("Ooops! Failed, try again!");
  }
  public render() {
    return (
      <div className="checkout">
        <div className="card-number-holder card-item-holder">
            <CardNumberElement style={style}/>
        </div>
        <div className="cvc-expiry card-item-holder">
          <div className="card-expiry-holder">
            <CardExpiryElement style={style}/>
          </div>
          <div className="card-cvc-holder">
            <CardCVCElement style={style} />
          </div>
        </div>
        <button className="checkout-button green-button" type="submit" onClick={this.submit}>
              Complete Order
            </button>
            <div className="card-icons">
              <img src={visa} alt="visa icon" title="Visa"/>
              <img src={mastercard} alt="mastercard icon" title="Mastercard"/>
              <img src={amex} alt="amex icon" title="American Express"/>
              <img src={discovercard} alt="discovercard icon" title="Discover Card"/>
            </div>
            <p className="checkout-safe">100% Safe &amp; Secure</p>
      </div>
    );
  }
}

export default injectStripe(CheckoutForm);



// WEBPACK FOOTER //
// ./src/pages/Subscription/checkoutForm.Component.tsx